import { graphqlClient } from "../../../client";
import mutationDocument from "./logClientErrorMutation.graphql";
import type { Mutations, MutationsLogClientErrorArgs, InputLogClientErrorType } from "@/core/api/graphql/types";

export const logClientError = async (payload: InputLogClientErrorType): Promise<boolean> => {
  const { data } = await graphqlClient.mutate<Required<Pick<Mutations, "logClientError">>, MutationsLogClientErrorArgs>(
    {
      mutation: mutationDocument,
      variables: {
        command: payload,
      },
    },
  );

  return data?.logClientError ?? false;
};
